import Vue from "vue";
import VueRouter from 'vue-router'
import Paginate from 'vuejs-paginate'

import ProfileSummary from './ProfileSummary';
import ProfileEdit from './ProfileEdit';
import FavoriteOffers from './FavoriteOffers';
import FavoriteOffersCompare from './FavoriteOffersCompare';
import axios from "axios";

Vue.use(VueRouter);
Vue.prototype.$http = axios;

Vue.component('paginate', Paginate);

// Vue Moment
import moment from 'moment';
const lang = $('body').data().locale;
const enPrefix = lang === 'en' ? '/en' : '';

moment.locale(lang);

Vue.use(require('vue-moment'), {moment});

const routes = [
    {
        path: '/',
        name: 'profile',
        component: ProfileSummary
    },
    {
        path: '/edit',
        name: 'edit',
        component: ProfileEdit
    },
    {
        path: '/favorite-offers',
        name: 'favorite-offers',
        component: FavoriteOffers
    },
    {
        path: '/compare-offers',
        name: 'compare-offers',
        component: FavoriteOffersCompare
    }
];

const router = new VueRouter({
    routes,
});

let UserProfile = new Vue({
    el: '#profile',
    props: {
        userFavorites: [],
    },
    data: {
        imageData: "/assets/images/placeholders/placeholder-user.jpg",

        clearAllFavorites: false,

        userIsFavoritesUpdate: false,
        updateFavorites: [],
    },
    router,
    methods: {
        uploadImage(event) {
            const input = event.target;
            if (input.files && input.files[0]) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.imageData = e.target.result;
                    console.log(this.imageData);
                };
                reader.readAsDataURL(input.files[0]);
            }
        },
        trigger() {
            document.getElementById("file-upload").click();
        },
        /**
         * Watch for emitted value from child component
         */
        isClear(value) {
            this.clearAllFavorites = value;
        },

        /**
         * Watch for emitted value from child component
         */
        isFavoritesUpdate(value) {
            this.userIsFavoritesUpdate = value;
        },
        favoritesUpdated(value) {
            // Updated Offers
            this.updateFavorites = value;
            console.log('Watcher'); console.log(this.updateFavorites);
        }
    },
});
